import Blog from "../blog/Blog";
import {
  Bottom,
  BtnDiv,
  Button,
  Container,
  Title,
  Top,
} from "./Articles.Element";
import axios from "axios";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const Articles = () => {
  const [latestBlogs, setLatestBlogs] = useState([]);
  useEffect(() => {
    const getLatestArticles = async () => {
      try {
        const res = await axios.get("https://sumail-code.onrender.com/api/v1/blogs/latest-3-blogs");
        setLatestBlogs(res.data.data.blogs);
      } catch (err) {
        console.log(err);
      }
    };
    getLatestArticles();
  }, []);
  return (
    <Container id='articles'>
      <Top>
        <Title>ARTICLES</Title>
        <BtnDiv>
          <Link
            // reloadDocument
            style={{ textDecoration: "none", color: "inherit" }}
            to='/'
          >
            <Button>See All</Button>
          </Link>
        </BtnDiv>
      </Top>
      <Bottom>
        {latestBlogs.map((blog, i) => (
          <Blog blog={blog} key={i} />
        ))}
      </Bottom>
    </Container>
  );
};

export default Articles;
